import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/hyviru_logo.webp";
import { FiMenu, FiX } from "react-icons/fi";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="sticky top-0 z-50 shadow-md">
      {/* Desktop Header */}
      <div className="hidden lg:flex justify-between items-center bg-gray-200 py-6 px-8">
        <img
          src={logo}
          alt="logo"
          className="w-[200px] h-[100px] rounded-lg cursor-pointer"
          onClick={() => navigate("/")}
        />
        <nav className="flex space-x-8">
          <Link
            to="/"
            className="py-2 px-4 rounded-md text-lg hover:bg-primary hover:text-white"
          >
            Home
          </Link>
          <Link
            to="/about-us"
            className="py-2 px-4 rounded-md text-lg hover:bg-primary hover:text-white"
          >
            About Us
          </Link>
          <Link
            to="/services"
            className="py-2 px-4 rounded-md text-lg hover:bg-primary hover:text-white"
          >
            Services
          </Link>
          <Link
            to="/contact-us"
            className="py-2 px-4 rounded-md text-lg hover:bg-primary hover:text-white"
          >
            Contact
          </Link>
        </nav>
      </div>

      {/* Mobile Header */}
      <div className="lg:hidden bg-gray-200 py-4 px-6 flex justify-between items-center">
        <img
          src={logo}
          alt="logo"
          className="w-[150px] h-[80px] rounded-lg cursor-pointer"
          onClick={() => navigate("/")}
        />
        <button
          onClick={toggleMenu}
          className="text-3xl text-primary focus:outline-none"
        >
          {isOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu (Dropdown) */}
      {isOpen && (
        <nav className="lg:hidden flex flex-col items-end bg-gray-100 py-4 px-6 space-y-4">
          <Link
            to="/"
            className="py-2 px-4 rounded-md hover:bg-primary hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about-us"
            className="py-2 px-4 rounded-md hover:bg-primary hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            About Us
          </Link>
          <Link
            to="/services"
            className="py-2 px-4 rounded-md hover:bg-primary hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Services
          </Link>
          <Link
            to="/contact-us"
            className="py-2 px-4 rounded-md hover:bg-primary hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Contact
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
